import {
    LIST_EVENTS, LIST_EVENTS_FAILURE, LIST_EVENTS_SUCCESS, UPDATE_EVENTS_FILTER,
    OPEN_EVENT_DETAIL_DIALOG, CLOSE_EVENT_DETAIL_DIALOG
} from './EventActionTypes';

export const updateEventListFilter = (filter) => ({
    type: UPDATE_EVENTS_FILTER,
    filter
})
export const listEvents = (page = 0) => ({
    type: LIST_EVENTS,
    page,
})
export const listEventsSucceeded = (events) => ({
    type: LIST_EVENTS_SUCCESS,
    events
})
export const listEventsFailed = (error) => ({
    type: LIST_EVENTS_FAILURE,
    error
})
export const openEventDetailDialog = (event) => ({
    type: OPEN_EVENT_DETAIL_DIALOG,
    event
})
export const closeEventDetailDialog = () => ({
    type: CLOSE_EVENT_DETAIL_DIALOG
})